<template>
  <modules-table :view="view" :row-click-enabled="false"/>
</template>

<script>
import { mapState } from 'vuex'
import modulesTable from './table'

export default {
  components: {
    modulesTable
  },
  computed: {
    ...mapState('modules', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/modules/archived.vue